import React  from "react";
import EmployeeLeaveCreditsTable from "./components/EmployeeLeaveCreditsTable";

const EmployeeLeaveCredits = () => {
	return (
	    <div>
	      	<EmployeeLeaveCreditsTable/>
		</div>
    );
};
export default EmployeeLeaveCredits;